// extracted by mini-css-extract-plugin
export default {"variantName":"TiVoAppSubRow__variantName-Shqb3","date":"TiVoAppSubRow__date-jtY0E","menu":"TiVoAppSubRow__menu-Lmm_s"};